import { render, staticRenderFns } from "./VOCTemplateGeneration.vue?vue&type=template&id=22056b70&scoped=true&"
import script from "./VOCTemplateGeneration.vue?vue&type=script&lang=js&"
export * from "./VOCTemplateGeneration.vue?vue&type=script&lang=js&"
import style0 from "./VOCTemplateGeneration.vue?vue&type=style&index=0&id=22056b70&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22056b70",
  null
  
)

export default component.exports